import React, { memo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import FloatingHeader from '../components/layout/FloatingHeader';
import Footer from '../components/Footer';
import PageMeta from '../components/PageMeta';
import { texte, PANELS } from '../components/startseite/texte';
import { starteAbschnitte } from '../components/startseite/abschnitte';
import StartAbschnitte from '../components/startseite/StartAbschnitte';
import Lichtszene from '../components/licht/Lichtszene';
import '../components/startseite/startseite.css';
import { SEITEN_BLENDE } from '../components/animations/seitenBlende';

// Kostenlos-Seite (/kostenlos, /en/free): aufgebaut wie die Werkzeuge-Seite, nur mit den Gratis-Sachen
// als Hauptbereich (Suche, Filter, Kacheln, Zeitleiste „so kommst du dran“), darunter Werkzeuge,
// All-in-One und Installer.

const Inhalt = memo(function Inhalt({ en }) {
  return <StartAbschnitte en={en} seite="kostenlos" />;
});

export default function Kostenlos() {
  const location = useLocation();
  const en = location.pathname.startsWith('/en/') || location.pathname === '/en';
  const wurzel = useRef(null);

  useEffect(() => {
    const T = texte(en);
    return starteAbschnitte({ wurzel: wurzel.current, T: T.szene, panels: PANELS, preise: T.preise });
  }, [en]);

  return (
    <motion.div {...SEITEN_BLENDE}>
      <PageMeta
        title={en ? 'Free After Effects presets & footage | DAVIDMEDIA' : 'Kostenlose After-Effects-Presets & Footage | DAVIDMEDIA'}
        description={en
          ? 'Free text animations, animated gradients and the Flow Panel for After Effects. Download directly or get everything in the free David Media Installer.'
          : 'Kostenlose Text-Animationen, animierte Verläufe und das Flow Panel für After Effects. Direkt laden oder alles im kostenlosen David Media Installer.'}
        url={en ? 'https://www.davidmedia.de/en/free' : 'https://www.davidmedia.de/kostenlos'}
      />
      <FloatingHeader />
      <div className="startseite" ref={wurzel}>
        <Lichtszene />
        <Inhalt en={en} />
      </div>
      <div className="relative z-10">
        <Footer />
      </div>
    </motion.div>
  );
}
